import React from "react";
import { VisualisationsProvider } from "../contexts/visualisations-context";
import CartoMapVisualisations from "./CartoMapVisualisations";

export default ({ id }) => {
  return (
    <VisualisationsProvider>
      <CartoMapVisualisations id={id} />
    </VisualisationsProvider>
  );
};
